<template>
  <div>

    <!--hero section start-->
    <section class="ptb-120 child-phone-section text-white">
        <div class="container">
            <div class="row align-items-center justify-content-lg-between">
                <div class="col-xl-5 col-lg-5">
                    <div class="hero-content-wrap text-center text-xl-start text-lg-start" data-aos="fade-right">
                        <h2 class="text-white">Safe Phone & Tablet for Kids </h2>
                        <p class="lead">Safe smartphone & Tablets for children - developed to give parents security and children freedom.</p>
                        <div class="hero-subscribe-form-wrap pt-4 position-relative m-auto m-xl-0 d-none d-md-block d-lg-block d-xl-block">
                            <form id="subscribe-form" name="email-form" class="hero-subscribe-form d-block d-lg-flex d-md-flex">
                                <!--<input type="email" class="form-control me-2" name="Email" data-name="Email" placeholder="Enter Your Email Address" id="email-address" required="">-->
                                <input type="button" value="Order Now" class="btn btn-warning mt-3 mt-lg-0 mt-md-0" @click="$router.push({ path: '/shop'})">
                            </form>
                            <ul class="nav subscribe-feature-list mt-3">
                                <li class="nav-item">
                                    <span class="ms-0"><i class="far fa-check-circle  me-2"></i>Free Shipping</span>
                                </li>
                                <li class="nav-item">
                                    <span><i class="far fa-check-circle  me-2"></i>24*7 Supports</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 mt-4 mt-xl-0">
                    <div class="hero-img-wrap position-relative" data-aos="fade-left">
                        <!--animated shape start-->
                        <ul class="position-absolute animate-element parallax-element shape-service hide-medium">
                            
                        </ul>
                        <!--animated shape end-->
                        <div class="hero-img-wrap position-relative">
                            <div class="hero-screen-wrap">
                                <div class="phone-screen">
                                    <img src="assets/img/home/section1-phone1.png" alt="hero image" class="position-relative img-fluid">
                                </div>
                                <div class="mac-screen">
                                    <img src="assets/img/home/section1-image2.png" alt="hero image" class="position-relative img-fluid rounded-custom">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--hero section end-->
    
    <!--promo section start-->
    <!--<div class="customer-section pb-120">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-12">
                    <ul class="customer-logos-grid text-center list-unstyled mb-0">
                        <li>
                            <img src="assets/img/home/google-logo.png" width="140" alt="clients logo" class="img-fluid customer-logo-gray p-1 p-md-2 p-lg-3 m-auto mt-1" data-aos="fade-up">
                        </li>
                        <li>
                            <img src="assets/img/home/apple-text-logo-white-bg.png" width="140" alt="clients logo" class="img-fluid customer-logo-gray p-1 p-md-2 p-lg-3 m-auto" data-aos="fade-up" data-aos-delay="50">
                        </li>
                        <li>
                            <img src="assets/img/home/samsung.png" width="150" alt="clients logo" class="img-fluid customer-logo-gray p-1 p-md-2 p-lg-3 m-auto" data-aos="fade-up" data-aos-delay="100">
                        </li>
                        <li>
                            <img src="assets/img/home/Tabnova.png" width="150" alt="clients logo" class="img-fluid customer-logo-gray p-1 p-md-2 p-lg-3 m-auto mt-3" data-aos="fade-up" data-aos-delay="150">
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>-->
    <!--promo section end-->
    
    <!--customers section start-->
    <!--<section class="promo-section ptb-120 bg-light ">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-6">
                    <div class="section-heading text-center" data-aos="fade-up">
                        <h2>Our Customers Get Results</h2>
                        <p>Progressively deploy market positioning catalysts for change and technically sound.
                            Authoritatively with backward-compatible
                            e-services. </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4 mt-4 mt-lg-0 mt-md-0">
                    <div class="bg-dark p-5 text-center d-flex flex-column h-100 rounded-custom" data-aos="fade-up" data-aos-delay="100">
                        <div class="promo-card-info mb-4">
                            <h3 class="display-5 fw-bold mb-4"><i class="far fa-fingerprint text-warning me-2"></i> 10x
                            </h3>
                            <p>Embrace distinctive best practices after B2B syndicate backend internal or whereas edge
                                process improvements. </p>
                        </div>
                        <div class="mt-auto">
                            <img src="assets/img/clients/client-logo-4.svg" width="120" alt="clients" class="img-fluid me-auto customer-logo">
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 mt-4 mt-lg-0 mt-md-0">
                    <div class="bg-dark p-5 text-center d-flex flex-column h-100 rounded-custom" data-aos="fade-up" data-aos-delay="150">
                        <div class="promo-card-info mb-4">
                            <h3 class="display-5 fw-bold mb-4"><i class="far fa-paper-plane text-warning me-2"></i> 5k
                            </h3>
                            <p>Rapidiously embrace distinctive best practices B2B syndicate backend internal or whereas
                                process improvements. </p>
                        </div>
                        <div class="mt-auto">
                            <img src="assets/img/clients/client-logo-2.svg" width="120" alt="clients" class="img-fluid me-auto customer-logo">
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 mt-4 mt-lg-0">
                    <div class="bg-dark p-5 text-center d-flex flex-column h-100 rounded-custom" data-aos="fade-up" data-aos-delay="200">
                        <div class="promo-card-info mb-4">
                            <h3 class="display-5 fw-bold mb-4"><i class="far fa-chart-pie-alt text-warning me-2"></i>
                                95%</h3>
                            <p>Distinctive best practices after B2B syndicate internal or whereas bleeding-edge process
                                improvements. </p>
                        </div>
                        <div class="mt-auto">
                            <img src="assets/img/clients/client-logo-3.svg" width="120" alt="clients" class="img-fluid me-auto customer-logo">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>-->
    <!--customers section end-->

    <!--feature section start-->
    <section class="feature-section two-bg-dark-light pt-5">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-6 col-md-6">
                    <div class="image-wrap mb-5 mb-md-0 mb-lg-0 mb-xl-0" data-aos="fade-up">
                        <img src="assets/img/home/section2-photo3.png" alt="feature img" class="img-fluid shadow rounded-custom">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="feature-content-wrap" data-aos="fade-up" data-aos-delay="50">
                        <h4 class="h5 text-primary">Advanced Features</h4>
                        <h2 class="text-primary">One Step Solutions</h2>
                        <!--<p>Tailored for your child</p>-->
                        <ul class="list-unstyled mt-5">
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-primary rounded me-4">
                                    <i class="fas fa-user-friends"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">Completely under your control</h3>
                                    <p class="text-start">Manage your app downloads, set screen time limits and keep an eye on usage.</p>
                                </div>
                            </li>
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-danger rounded me-4">
                                    <i class="fas fa-heartbeat"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">A healthy start to the digital world</h3>
                                    <p class="text-start">Help your child discover the positive side of technology while keeping harmful content out. No uncontrolled browser access, no social media</p>
                                </div>
                            </li>
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-secondary rounded me-4">
                                    <i class="fas fa-certificate"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">Certified app recommendations</h3>
                                    <p class="text-start">Access a selection of safe, educational and entertaining apps selected by child development experts.</p>
                                </div>
                            </li>
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-info rounded me-4">
                                    <i class="fas fa-cog"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">No complicated set-up</h3>
                                    <p class="text-start">Each phone is delivered pre-configured and does not require complicated parental control setup.</p>
                                </div>
                            </li>
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-warning rounded me-4">
                                    <i class="fas fa-graduation-cap"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">Learning instead of social media</h3>
                                    <p class="text-start">Your child can explore educational apps and communicate safely with friends - without social media or unrestricted internet access.</p>
                                </div>
                            </li>
                            <li class="d-flex align-items-start mb-4">
                                <div class="icon-box bg-primary rounded me-4">
                                    <i class="fas fa-child"></i>
                                </div>
                                <div class="icon-content">
                                    <h3 class="h5 text-start">Children can have a say</h3>
                                    <p class="text-start">Each app is evaluated and shown to you from the child's perspective - this encourages dialog and the child's own perception of screen time and app use.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--feature section end-->

    <!--feature section start-->
    <section class="feature-section child-phone-section pt-5 pb-5">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-6 col-md-6">
                    <div class="image-wrap mb-5 mb-md-0 mb-lg-0 mb-xl-0" data-aos="fade-up">
                        <img src="assets/img/kid_Girl.jpg" alt="feature img" class="img-fluid shadow rounded-custom">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="feature-content-wrap" data-aos="fade-up" data-aos-delay="50">
                        <h4 class="text-white pb-4"><strong>Are you thinking about giving your child their first cell phone?</strong></h4>
                        <p class="text-start text-white">How do I balance control and the promotion of independence?</p>
                        <p class="text-start text-white">Which apps are really age-appropriate and promote learning instead of social media?</p>
                        <p class="text-start text-white">How do I set the cell phone so that my child can't bypass it?</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--feature section end-->

    <!--our work process start-->
    <section class="work-process pt-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-10">
                    <div class="section-heading text-center" data-aos="fade-up">
                        <h2 class="text-primary">Overview</h2>
                        <p>
                            The Kids smartphone was developed to give you as a parent more control and your child a safe digital experience.
                            <br><b>Our solution: A pre-configured Samsung Galaxy smartphone.</b>
                        </p>
                    </div>
                </div>
            </div>
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-5 col-md-12 order-1 order-lg-0">
                    <div class="img-wrap" data-aos="fade-up" data-aos-delay="50">
                        <img src="assets/img/home/section3-image.jpg" alt="work process" class="img-fluid rounded-custom">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 order-0 order-lg-1">
                    <ul class="work-process-list list-unstyled text-start">
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="50">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="fas fa-cog"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">No complicated setup</span>
                                <p class="text-justify">Parental control functions are already pre-installed! 
                                </p>
                            </div>
                        </li>
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="100">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="far fa-chart-bar"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">Current screen time monitoring</span>
                                <p class="text-justify">Keep an overview.</p>
                            </div>
                        </li>
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="150">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="fas fa-ban"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">No access to social media</span>
                                <p class="text-justify">Safe and child-friendly use</p>
                            </div>
                        </li>
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="150">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="fas fa-download"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">App download control</span>
                                <p class="text-justify">Your decide what ends up on your cell phone.</p>
                            </div>
                        </li>
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="150">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="far fa-smile"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">Age-appropriate app recommendations</span>
                                <p class="text-justify">Recommended by experts.</p>
                            </div>
                        </li>
                        <li class="d-flex align-items-start mb-4" data-aos="fade-up" data-aos-delay="150">
                            <div class="process-icon-2 border border-2 rounded-custom bg-white me-4 mt-2">
                                <i class="fas fa-mobile-alt"></i>
                            </div>
                            <div class="icon-content">
                                <span class="text-primary h6">Cool phone</span>
                                <p class="text-justify">It's a standard Samsung phone and not a "kids" phone without the kids smartphone logo! </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!--our work process end-->

    <!--<section class="feature-section child-phone-section pt-5 pb-5 mt-3">
        <div class="container">
            <div class="section-heading text-center" data-aos="fade-up">
                <h2>Explore all the features</h2>
            </div>

            <div class="scrolling-wrapper">
                
                <div class="feature-card">
                    <div class="position-relative">
                    <img src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid" alt="Feature Image">
                    <div class="card-img-overlay-custom">
                        <div><strong>Blocked</strong></div>
                        <div style="color: green;"><strong>Allowed</strong></div>
                    </div>
                    </div>
                    <div class="p-3">
                    <h6 class="fw-bold">Approve or deny contacts</h6>
                    <p class="mb-2 small">Help protect your kid from strangers by choosing who they can talk to.</p>
                    <p class="small"><strong>Included with:</strong><br>Starter plan | Advanced plan</p>
                    </div>
                </div>
                <div class="feature-card">
                    <div class="position-relative">
                    <img src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid" alt="Feature Image">
                    <div class="card-img-overlay-custom">
                        <div><strong>Blocked</strong></div>
                        <div style="color: green;"><strong>Allowed</strong></div>
                    </div>
                    </div>
                    <div class="p-3">
                    <h6 class="fw-bold">Approve or deny contacts</h6>
                    <p class="mb-2 small">Help protect your kid from strangers by choosing who they can talk to.</p>
                    <p class="small"><strong>Included with:</strong><br>Starter plan | Advanced plan</p>
                    </div>
                </div>
                <div class="feature-card">
                    <div class="position-relative">
                    <img src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid" alt="Feature Image">
                    <div class="card-img-overlay-custom">
                        <div><strong>Blocked</strong></div>
                        <div style="color: green;"><strong>Allowed</strong></div>
                    </div>
                    </div>
                    <div class="p-3">
                    <h6 class="fw-bold">Approve or deny contacts</h6>
                    <p class="mb-2 small">Help protect your kid from strangers by choosing who they can talk to.</p>
                    <p class="small"><strong>Included with:</strong><br>Starter plan | Advanced plan</p>
                    </div>
                </div>
                <div class="feature-card">
                    <div class="position-relative">
                    <img src="https://b2b.novaemm.com/img/vue-logo.png" class="img-fluid" alt="Feature Image">
                    <div class="card-img-overlay-custom">
                        <div><strong>Blocked</strong></div>
                        <div style="color: green;"><strong>Allowed</strong></div>
                    </div>
                    </div>
                    <div class="p-3">
                    <h6 class="fw-bold">Approve or deny contacts</h6>
                    <p class="mb-2 small">Help protect your kid from strangers by choosing who they can talk to.</p>
                    <p class="small"><strong>Included with:</strong><br>Starter plan | Advanced plan</p>
                    </div>
                </div>
                
            
            </div>
        </div>
    </section>-->

    
    <!--About Us section start-->
    <section class="feature-section child-phone-section pt-5 pb-5">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-12 col-md-12">
                    <div class="feature-content-wrap" data-aos="fade-up" data-aos-delay="50">
                        <h4 class="text-white pb-4"><strong>About Us</strong></h4>
                        <p class="text-start text-white">mywingio.com was founded by Rajiv Azhapilli and Dijo Xavier, two passionate innovators with deep expertise in telecom and software technology. Their shared vision is to empower families by making technology safer and more accessible for children.</p>
                        <p class="text-start text-white">Rajiv’s background spans product management and telecom infrastructure, having held key roles at industry leaders such as Samsung Electronics, Nokia Siemens Networks, and Aricent. He brings a strategic approach to building secure, user-friendly devices that meet the needs of modern families.</p>
                        <p class="text-start text-white">Dijo complements this with his strong foundation in software engineering and leadership experience at companies like Samsung Electronics and Symbian Ltd. His technical insight ensures that every Wingio device is equipped with advanced parental controls and robust safety features.</p>
                        <p class="text-start text-white">Together, Rajiv and Dijo are launching their first consumer hardware product-a smartphone designed specifically for kids, with built-in parental controls to give parents peace of mind. Their goal is to create smart, safe technology that supports healthy digital habits and helps families stay connected, securely.</p>
                        <p class="text-start text-white">At Wingio.com, Rajiv and Dijo are committed to redefining what it means for children to interact with technology-making it safer, smarter, and more family-friendly.</p>
                    </div>
                </div>
                <!--<div class="col-lg-6 col-md-6">
                    <div class="profile-card">
                        <img src="assets/img/kid_Girl.jpg" alt="Friederike von Waldenfels" class="profile-image">
                        <div class="profile-name">Friederike von Waldenfels</div>
                        <div class="profile-role">Founder</div>
                        <p class="profile-desc">
                        "I have been building start-ups in the e-commerce and technology sector for 15 years. This is my heart project as a mother and entrepreneur."
                        </p>
                    </div>
                </div>-->
            </div>
        </div>
    </section>
    <!--About us section end-->
    
    <!--customer review slider section start-->
    <section class="testimonial-section  pt-5 pb-5">
        <div class="container">
            <div class="row justify-content-center align-content-center">
                <div class="col-md-10 col-lg-6">
                    <div class="section-heading text-center" data-aos="fade-up">
                        <h2 class="text-primary">What They Say About Us</h2>
                        <!--<p>Uniquely promote adaptive quality vectors rather than stand-alone e-markets. pontificate alternative architectures whereas iterate.</p>-->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="position-relative w-100" data-aos="fade-up" data-aos-delay="50">
                        <div class="swiper-container testimonialSwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide bg-custom-light text-white  p-5 rounded-custom position-relative">
                                    <img src="assets/img/testimonial/quotes-dot.svg" alt="quotes" width="100" class="img-fluid position-absolute left-0 top-0 z--1 p-3">
                                    <div class="d-flex mb-32 align-items-center">
                                        <img src="assets/img/testimonial/Wendy.jpg" class="img-fluid me-3 rounded" width="60" alt="user">
                                        <div class="author-info">
                                            <h6 class="mb-0">Wendy Johnson</h6>
                                        </div>
                                    </div>
                                    <blockquote class="text-black">
                                        <h6>Best Indeed</h6>
                                        I’ve never been more impressed with a phone designed specifically for kids! But Kids Smartphone is life changer. The Kids Smartphone gives me full control over the apps my child can use, with a carefully curated selection that ensures a safe and appropriate experience. 
                                    </blockquote>
                                    <ul class="review-rate mb-0 mt-2 list-unstyled list-inline">
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                    </ul>
                                </div>
                                <div class="swiper-slide bg-custom-light text-white  p-5 rounded-custom position-relative">
                                    <img src="assets/img/testimonial/quotes-dot.svg" alt="quotes" width="100" class="img-fluid position-absolute left-0 top-0 z--1 p-3">
                                    <div class="d-flex mb-32 align-items-center">
                                        <img src="assets/img/testimonial/Sandra.jpg" class="img-fluid me-3 rounded" width="60" alt="user">
                                        <div class="author-info">
                                            <h6 class="mb-0">Sandra Meister</h6>
                                        </div>
                                    </div>
                                    <blockquote class="text-black">
                                        <h6>Must have for every parent</h6>
                                        It’s reassuring to know that screen time is managed without constant supervision. If you’re a parent looking for a smart, kid-friendly phone with built-in parental controls, this is the perfect choice!
                                    </blockquote>
                                    <ul class="review-rate mb-0 mt-2 list-unstyled list-inline">
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                    </ul>
                                </div>
                                <div class="swiper-slide bg-custom-light text-white  p-5 rounded-custom position-relative">
                                    <img src="assets/img/testimonial/quotes-dot.svg" alt="quotes" width="100" class="img-fluid position-absolute left-0 top-0 z--1 p-3">
                                    <div class="d-flex mb-32 align-items-center">
                                        <img src="assets/img/testimonial/Richard.jpg" class="img-fluid me-3 rounded" width="60" alt="user">
                                        <div class="author-info">
                                            <h6 class="mb-0">Richard woods</h6>
                                        </div>
                                    </div>
                                    <blockquote class="text-black">
                                        <h6>Love the safety first approach</h6>
                                        I love that I can approve only the apps that are safe and appropriate for my child. The ability to set different modes throughout the day means my child stays focused during school with educational apps and can enjoy games or music at the right time. 
                                    </blockquote>
                                    <ul class="review-rate mb-0 mt-2 list-unstyled list-inline">
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                        <li class="list-inline-item"><i class="fas fa-star text-warning"></i></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <span class="swiper-button-next"></span>
                        <span class="swiper-button-prev"></span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--customer review slider section end-->

    
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import PaymentService from "../services/PaymentService";
import {useToast} from 'vue-toast-notification';
const $toast = useToast();

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';


export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    VueTelInput
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  methods: {
  },
  beforeMount() {
  },
  created () {
  },
}
</script>
<style scoped>

</style>